import Navigation from '../../components/feature/Navigation';

export default function AboutPage() {
  const stats = [
    { number: "2023", label: "Established Platform", isStacked: true },
    { number: "50+", label: "Episodes Published" },
    { number: "15+", label: "Industry Experts" }
  ];

  const scrollToHost = () => {
    const hostSection = document.getElementById('host-section');
    if (hostSection) {
      hostSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openEpisode = () => {
    window.open('https://www.youtube.com/@themusclehustlepodcast', '_blank');
  };

  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      
      {/* About The Podcast Section */}
      <section className="py-16 md:py-20 bg-black">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 md:gap-16 items-center max-w-7xl mx-auto">
            <div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 md:mb-8 leading-tight text-center">
                About The
                <span className="text-red-600 block">Muscle Hustle Podcast</span>
              </h2>

              <p className="text-xl md:text-2xl text-gray-300 mb-6 md:mb-8 leading-relaxed">
                We're on a mission to bring you the most compelling conversations with visionaries, entrepreneurs, and thought leaders who embody The Grind. The Drive. The Hustle. Each episode is carefully crafted to deliver insights that matter to those who Respect My Hustle.
              </p>

              <p className="text-lg md:text-xl text-gray-300 mb-8 md:mb-10 leading-relaxed">
                Where the Everyday Hustle is Respected - from cutting-edge fitness and business strategies to personal development and financial innovation. We explore the topics that define success for the everyday hustler. Join our community of driven minds and forward-thinking individuals.
              </p>

              <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
                <button className="bg-red-600 hover:bg-red-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                  Start Listening
                </button>
                <button 
                  onClick={scrollToHost}
                  className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-black px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  Meet the Host
                </button>
              </div>
            </div>

            <div className="relative order-first lg:order-last">
              <img
                src="https://public.readdy.ai/ai/img_res/ebcf3c8227125d437d9c2110da3f9449.jpg"
                alt="MHP Episode 43: Hustli'm with Melody - The Muscle Hustle Podcast"
                className="rounded-2xl shadow-2xl object-cover object-top w-full h-[400px] md:h-[500px] cursor-pointer hover:scale-105 transition-transform duration-300"
                onClick={openEpisode}
              />

              <div 
                className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-gray-900 border border-gray-700 rounded-2xl shadow-xl p-4 md:p-6 max-w-xs cursor-pointer hover:scale-105 transition-transform duration-300"
                onClick={openEpisode}
              >
                <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-4">
                  <div className="w-2 h-2 md:w-3 md:h-3 bg-red-600 rounded-full animate-pulse"></div>
                  <span className="text-xs md:text-sm font-semibold text-gray-300">WATCH NOW</span>
                </div>
                <p className="text-white font-semibold text-sm md:text-base leading-tight">
                  "MHP Episode 43: Hustli'm with Melody"
                </p>
                <p className="text-gray-400 text-xs md:text-sm mt-1">Latest Episode • New</p>
                <div className="flex items-center gap-2 mt-2">
                  <div className="w-4 h-4 flex items-center justify-center bg-red-600 rounded-full">
                    <i className="ri-play-fill text-white text-xs"></i>
                  </div>
                  <span className="text-xs text-gray-400">Click to watch</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-20 md:mt-24 pt-16 md:pt-20 border-t border-gray-700">
            <div className="grid grid-cols-3 gap-12 md:gap-16 lg:gap-24 xl:gap-32 max-w-6xl mx-auto">
              {stats.map((stat, index) => (
                <div key={index} className="text-center group">
                  {stat.isStacked ? (
                    <>
                      <div className="text-4xl md:text-5xl lg:text-7xl font-bold text-red-600 mb-2 group-hover:scale-110 transition-transform duration-300">
                        {stat.number}
                      </div>
                      <div className="text-gray-300 font-semibold text-base md:text-lg lg:text-xl">{stat.label}</div>
                    </>
                  ) : (
                    <>
                      <div className="text-4xl md:text-5xl lg:text-7xl font-bold text-red-600 mb-4 group-hover:scale-110 transition-transform duration-300">
                        {stat.number}
                      </div>
                      <div className="text-gray-300 font-semibold text-base md:text-lg lg:text-xl">{stat.label}</div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* Host Section */}
      <section id="host-section" className="py-16 md:py-20 bg-gray-900">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 md:gap-16 items-center max-w-7xl mx-auto">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/86406a665a28ba21ddd5afd6a9d3db96/245ce2d3504b7024d6bc73dec1e86a72.jfif"
                alt="Kokes - Host of The Muscle Hustle Podcast"
                className="rounded-2xl shadow-2xl object-cover object-top w-full h-[500px] md:h-[600px]"
              />
              
              <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-gray-800 border border-gray-600 rounded-2xl shadow-xl p-4 md:p-6 max-w-xs">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center">
                    <i className="ri-trophy-fill text-white text-sm"></i>
                  </div>
                  <span className="text-sm font-semibold text-gray-300">MULTI-DISCIPLINARY FIGURE</span>
                </div>
                <p className="text-white font-semibold text-sm leading-tight italic">
                  "Unstoppable isn't a word I use. It's the way I move." - Kokes
                </p>
              </div>
            </div>

            <div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 md:mb-8 leading-tight text-center">
                Meet Your Host
                <span className="text-red-600 block">Kokes</span>
              </h2>

              <p className="text-xl md:text-2xl text-gray-300 mb-6 md:mb-8 leading-relaxed">
                Kokes' journey has been anything but ordinary. Sprinting her way as a professional track athlete, performed and choreographed as a touring dancer, competed as a professional bodybuilder, spun tracks as a resident DJ, and built multiple businesses from the ground up.
              </p>

              <p className="text-lg md:text-xl text-gray-300 mb-6 md:mb-8 leading-relaxed">
                Now, as your host of The Muscle Hustle Podcast, Kokes shares the lessons learned along the way. Helping listeners tap into their own hustle, she shares stories of resilience, creativity, and the drive it takes to win in fitness, business, and life through her own eyes.
              </p>

              <div className="grid grid-cols-2 gap-4 md:gap-6 mb-8">
                <div className="bg-gray-800 border border-gray-600 rounded-xl p-4 md:p-6 shadow-lg">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-run-line text-red-600 text-lg"></i>
                  </div>
                  <h4 className="font-bold text-white mb-2 text-base md:text-lg">Track &amp; Pro Bodybuilder</h4>
                </div>
                
                <div className="bg-gray-800 border border-gray-600 rounded-xl p-4 md:p-6 shadow-lg">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-music-line text-red-600 text-lg"></i>
                  </div>
                  <h4 className="font-bold text-white mb-2 text-base md:text-lg">Touring Dancer &amp; Resident DJ</h4>
                </div>
                
                <div className="bg-gray-800 border border-gray-600 rounded-xl p-4 md:p-6 shadow-lg">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-building-line text-red-600 text-lg"></i>
                  </div>
                  <h4 className="font-bold text-white mb-2 text-base md:text-lg">Entrepreneur</h4>
                </div>
                
                <div className="bg-gray-800 border border-gray-600 rounded-xl p-4 md:p-6 shadow-lg">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-mic-line text-red-600 text-lg"></i>
                  </div>
                  <h4 className="font-bold text-white mb-2 text-base md:text-lg">Podcast Host</h4>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
                <button 
                  onClick={() => window.open('https://www.instagram.com/themusclehustlepodcast', '_blank')}
                  className="bg-red-600 hover:bg-red-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-instagram-line"></i>
                  Follow The Hustle
                </button>
                <button 
                  onClick={() => window.open('https://www.youtube.com/@themusclehustlepodcast', '_blank')}
                  className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-black px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-youtube-line"></i>
                  Watch Episodes
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
